import React from "react";

import { Icon } from "components-lib";
import {
  MdHome,
  MdPerson,
  MdMessage,
  MdPayment,
  MdCalendarMonth,
  MdAssessment,
  MdBuild,
} from "react-icons/md";
import { PiUserListFill } from "react-icons/pi";
// Admin Imports
import MainDashboard from "views/admin/default";
// import Appointment from "views/admin/appointments";
// import Patient from "views/admin/patient";
// import Message from "views/admin/messages";
// import Bills from "views/admin/bills";
import Doctors from "views/admin/doctors";
import DoctorsList from "views/admin/doctorsList/DoctorsList";
import ClinicList from "views/admin/clinicList/ClinicList";
import FrontdeskList from "views/admin/frontdeskList/FrontdeskList";
import FrontdeskAppointments from "views/frontdesk/Appointments";
import ComponentShowcase from "views/ComponentShowcase";
import AuditLogs from "views/admin/auditLogs/AuditLogs";
// import Appointments from "views/admin/appointments";

// Auth Imports
// import SignInCentered from "views/auth/signIn";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: MainDashboard,
  },
  {
    name: "Doctors",
    layout: "/admin",
    path: "/doctor",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Doctors,
  },
  {
    name: "Front Desk Dashboard",
    layout: "/admin",
    path: "/frontdesk",
    icon: (
      <Icon as={MdCalendarMonth} width="20px" height="20px" color="inherit" />
    ),
    component: Doctors,
    secondary: true,
  },
  {
    name: "Doctors List",
    layout: "/admin",
    path: "/doctors-list",
    icon: (
      <Icon as={PiUserListFill} width="20px" height="20px" color="inherit" />
    ),
    component: DoctorsList,
  },
  {
    name: "Clinic List",
    layout: "/admin",
    path: "/clinics-list",
    icon: (
      <Icon as={PiUserListFill} width="20px" height="20px" color="inherit" />
    ),
    component: ClinicList,
  },
  {
    name: "Frontdesk List",
    layout: "/admin",
    path: "/frontdesk-list",
    icon: (
      <Icon as={PiUserListFill} width="20px" height="20px" color="inherit" />
    ),
    component: FrontdeskList,
  },
  {
    name: "Audit Logs",
    layout: "/admin",
    path: "/audit-logs",
    icon: (
      <Icon as={MdAssessment} width="20px" height="20px" color="inherit" />
    ),
    component: AuditLogs,
  },
  {
    name: "Component Showcase",
    layout: "/admin",
    path: "/showcase",
    icon: (
      <Icon as={MdBuild} width="20px" height="20px" color="inherit" />
    ),
    component: ComponentShowcase,
  },

];

export default routes;
